import React, { useState, useEffect } from "react";
import CuInput from "../../all-patient/components/CuInput";
import CuDropdown from "../../common_component/component/CuDropdown";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import {
  useCreateItem,
  useSecureUpdateItem,
} from "../../_helper/actions/mutation/items";
import { toast } from "react-toastify";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { useItemsFilter } from "../../_helper/actions/app/items";
import CuButton from "../../all-patient/components/CuButton";

const LabTestForm = ({ mode, handleEdit, handleCancel, id }) => {
  const [clinic] = useAtom(clinicAtom);
  const [formData, setFormData] = useState({
    name: "",
    related_names: [],
    display_name: "",
    ufm: "",
    test_category: "",
    lab_test_threshold: "",
  });

  const handleChange = (value, field) => {
    if (field === "related_names") {
      setFormData({
        ...formData,
        [field]: value.split(",").map((name) => name.trim()),
      });
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  const postLabTestMutation = useCreateItem(ApiEndPoint.MEDICINE_TAG_DATA);
  const patchLabTestMutation = useSecureUpdateItem(
    ApiEndPoint.MEDICINE_TAG_DATA
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      id: "",
      action: mode === "edit" ? "patchLabTest" : "postLabTest",
      clinic_id: clinic?.id,
      backend: "True",
      ...formData,
    };

    if (mode === "edit") {
      patchLabTestMutation.mutate(
        { id: null, data: payload },
        {
          onSuccess: () => {
            toast.success("Updated Successfully");
            handleCancel();
          },
          onError: (err) => {
            toast.error(err?.response?.data?.message);
          },
        }
      );
    } else {
      postLabTestMutation.mutate(payload, {
        onSuccess: () => {
          toast.success("Created Successfully");
          handleCancel();
        },
        onError: (err) => {
          toast.error(err?.response?.data?.message);
        },
      });
    }
  };

  const { data: ufmData } = useItemsFilter(
    ApiEndPoint.MEDICINE_TAG_DATA,
    `?action=getLabUfm&clinic_id=${clinic?.id}&backend=True`,
    clinic?.id ? true : false
  );

  const { data: categoryData } = useItemsFilter(
    ApiEndPoint.MEDICINE_TAG_DATA,
    `?action=getLabTestCategories&clinic_id=${clinic?.id}&backend=True`,
    clinic?.id ? true : false
  );

  const { data: thresholdData } = useItemsFilter(
    ApiEndPoint.MEDICINE_TAG_DATA,
    `?action=getLabTestThreshold&clinic_id=${clinic?.id}&backend=True`,
    clinic?.id ? true : false
  );

  const ufmOptions =
    ufmData?.map((ufm) => ({
      key: ufm.id,
      text: ufm.name,
      value: ufm.id,
    })) || [];

  const categoryOptions =
    categoryData?.map((category) => ({
      key: category.id,
      text: category.name,
      value: category.id,
    })) || [];

  const thresholdOptions =
    thresholdData?.map((threshold) => ({
      key: threshold.id,
      text: `Min: ${threshold.min_threshold}, Max: ${threshold.max_threshold}, Age Group: ${threshold.age_group}, Gender: ${threshold.gender}`,
      value: threshold.id,
    })) || [];

  return (
    <div className="cu-setup-create-container">
      <form className="cu-setup-create-form" onSubmit={handleSubmit}>
        <div className="cu-setup-create-form-input-container">
          <div className="cu-setup-create-form-input">
            <CuInput
              label="Name"
              required={true}
              onChange={(e) => handleChange(e.target.value, "name")}
              value={formData.name}
            />
          </div>
          <div className="cu-setup-create-form-input">
            <CuInput
              label="Display Name"
              onChange={(e) => handleChange(e.target.value, "display_name")}
              value={formData.display_name}
            />
          </div>
          <div className="cu-setup-create-form-input">
            <CuInput
              label="Related Names"
              onChange={(e) => handleChange(e.target.value, "related_names")}
              value={formData.related_names.join(", ")}
            />
          </div>
          <div className="cu-setup-create-form-input">
            <label>UFM</label>
            <CuDropdown
              options={ufmOptions}
              onChange={(value) => handleChange(value, "ufm")}
              value={formData.ufm}
            />
          </div>
          <div className="cu-setup-create-form-input">
            <label>Test Category</label>
            <CuDropdown
              options={categoryOptions}
              onChange={(value) => handleChange(value, "test_category")}
              value={formData.test_category}
            />
          </div>
          <div className="cu-setup-create-form-input">
            <label>Lab Test Threshold</label>
            <CuDropdown
              options={thresholdOptions}
              onChange={(value) => handleChange(value, "lab_test_threshold")}
              value={formData.lab_test_threshold}
            />
          </div>
        </div>
        <div className="cu-setup-create-form-btn-container">
          {mode !== "view" && (
            <CuButton
              className="cu-setup-create-form-btn cu-setup-create-form-save-btn"
              type="submit"
              isLoading={postLabTestMutation.isLoading}
            >
              Save
            </CuButton>
          )}
          {mode === "view" && (
            <CuButton
              className="cu-setup-create-form-btn cu-setup-create-form-save-btn"
              type="submit"
              onClick={handleEdit}
              isLoading={patchLabTestMutation.isLoading}
            >
              Edit
            </CuButton>
          )}
          <button
            className="cu-setup-create-form-btn cu-setup-create-form-cancel-btn"
            type="button"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default LabTestForm;
